const siteMetadata = {
  siteUrl: "https://admityogi.com",
  email: "contact@admityogi.com",
  title: "AdmitYogi",
  description: "Unpacking college admissions",
  language: "en-us",
  siteLogo: "/images/logo-black.svg",
};

export default siteMetadata;
